<template>
  <div class="loading_main" v-show="status !== 2">
    <div v-show="status === 1">
      <i class="el-icon-loading loading"></i>
    </div>
    <div v-show="status === 3 && !isEmptyDisappear">
      <i class="text">
        <slot name="empty">暂无数据</slot>
      </i>
    </div>
    <div v-show="status === 4">
      <i class="text">
        <slot name="fail">加载失败</slot>
      </i>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Loading",
        props: {
            //loading状态 1:正在加载 2:加载完成，且还有更多数据 3:加载完成，无更多数据 4:加载失败
            status: {
                required: false,
                type: Number,
                default: 2
            },
            /**
             * 无更多数据的时候是否隐藏
             */
            isEmptyDisappear: {
                default: false
            }
        }
    }
</script>

<style scoped>
  .loading_main {
    text-align: center
  }

  .loading_main > div {
    margin: 10px 0;
  }

  .text {
    color: #999;
    font-size: 14px;
    font-style: inherit;
  }

  .loading {
    color: #999;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/Loading.vue